import type { NextPage } from 'next';
import React from 'react';
import { ContentContext } from 'src/Context/ContactContext';
import Header from '../src/Components/molecules/Header/Header';
import Footer from '../src/Components/molecules/Footer/Footer';
import ContactForm from '../src/Components/molecules/ContactForm/ContactForm';

const Home: NextPage = () => (
    <>
        <Header />

        <div className="relative w-screen max-w-screen-xl m-auto">
            <ContentContext>
                <ContactForm />
            </ContentContext>
        </div>

        <Footer />
    </>
);

export default Home;
